import { Avatar, Box } from "@mui/material";
import React from "react";
import { KeyDriveBodyMin } from "../Fonts/Body/KeyDriveBodyMin";

interface IKeyDriveAvatar {
    avatarName?: string;
    Icon?: React.ReactNode | string | undefined;
    userImage?: string;
    avatarType: "Image" | "Icon" | "Name"
}

export function KeyDriveAvatar({
    avatarName,
    Icon,
    userImage,
    avatarType
}: IKeyDriveAvatar) {

    function handleAvatarName(name: string) : string
    {
      let names = name?.split(' ');
      let nameFirstLetters = []
       
      for(let i = 0; i < names?.length; i++)
      {
        nameFirstLetters.push(names[i][0]);
      }
    
      return nameFirstLetters.join("").toUpperCase();
    }

    function handleAvatarContent() : React.ReactNode
    {
        switch(avatarType) 
        {
            case "Name":
                return <KeyDriveBodyMin 
                    color="#22638D"
                    needBold={false}
                    needEllipses={false}
                    text={handleAvatarName(avatarName!)}
                />
            
            case "Image":
                return <Box 
                    component="img"
                    src={userImage}
                />

            case "Icon":
                return Icon;
        }
    }

    return (
        <Avatar
            sx={{
                height: '26px',
                width: '26px',
                color: '#22638D',
                backgroundColor: '#22638D1A',
                border: "1px solid #22638D33",
            }}
        >
            { handleAvatarContent() }
        </Avatar>
    )
}